import { Color } from 'module/ui/components/styles/colors';
import { WarningAltFilled } from '@carbon/icons-react';
import { ReactNode } from 'react';
import styled from 'styled-components';

const AlertWrapper = styled.div<{ color: Color }>`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--spacing-04);
  margin: var(--spacing-05) 0;
  background-color: var(--red-10);
  border-left: 4px solid var(--red-50);
  color: var(--red-60);

  svg {
    margin-right: var(--spacing-03);
    fill: var(--red-50);
  }
`;

interface ErrorAlertProps {
  message: ReactNode;
  color?: Color;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  color = 'red',
}) => {
  return (
    <AlertWrapper color={color}>
      <WarningAltFilled size={20} />
      {message}
    </AlertWrapper>
  );
};
